__turbopack_context__.v({
  "button": "styles-module__GRWFXG__button",
  "buttonRecommended": "styles-module__GRWFXG__buttonRecommended",
  "buttonSelected": "styles-module__GRWFXG__buttonSelected",
  "buttonSelectedRecommended": "styles-module__GRWFXG__buttonSelectedRecommended",
  "buttonWrapper": "styles-module__GRWFXG__buttonWrapper",
  "recommendationText": "styles-module__GRWFXG__recommendationText",
  "wrapper": "styles-module__GRWFXG__wrapper",
});
